import { render, staticRenderFns } from "./CustomFilter.vue?vue&type=template&id=beb4faea&scoped=true"
import script from "./CustomFilter.vue?vue&type=script&lang=js"
export * from "./CustomFilter.vue?vue&type=script&lang=js"
import style0 from "./CustomFilter.vue?vue&type=style&index=0&id=beb4faea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb4faea",
  null
  
)

export default component.exports